// SHADOW MARKET™ — Wallet comparator UI labels (ES/EN/SK).
export const COMPARADOR_UI = {
  es: {
    title: "Comparador de Wallets",
    subtitle: "35 wallets analizadas · Hardware + Hot · Encuentra la tuya",
    eyebrow: "TopWallet · Compara",
    filter_category: "Categoría",
    filter_type: "Tipo",
    type_all: "Todas",
    type_cold: "🧊 Cold (Hardware)",
    type_hot: "🔥 Hot (Software)",
    sort: "Ordenar por",
    sort_security: "Seguridad",
    sort_ease: "Facilidad",
    sort_price_asc: "Precio ↑",
    sort_price_desc: "Precio ↓",
    chains: "Redes",
    best_for: "Mejor para",
    pros: "✅ Ventajas",
    cons: "⚠️ Desventajas",
    security: "Seguridad",
    ease: "Facilidad",
    price: "Precio",
    free: "Gratis",
    free_short: "GRATIS",
    open_source: "Open Source",
    closed: "Cerrado",
    visit: "Visitar web",
    close: "Cerrar",
    details: "Ver detalles",
    cold: "COLD",
    hot: "HOT",
    showing: (n, total) => `Mostrando ${n} de ${total} wallets`,
    no_results: "No hay wallets que coincidan con tus filtros",
    reset: "Limpiar filtros",
    badges: { defi: "DeFi", mobile: "Móvil", desktop: "Desktop", nfc: "NFC", hw: "Hardware" },
  },
  en: {
    title: "Wallet Comparator",
    subtitle: "35 wallets analyzed · Hardware + Hot · Find yours",
    eyebrow: "TopWallet · Compare",
    filter_category: "Category",
    filter_type: "Type",
    type_all: "All",
    type_cold: "🧊 Cold (Hardware)",
    type_hot: "🔥 Hot (Software)",
    sort: "Sort by",
    sort_security: "Security",
    sort_ease: "Ease",
    sort_price_asc: "Price ↑",
    sort_price_desc: "Price ↓",
    chains: "Networks",
    best_for: "Best for",
    pros: "✅ Pros",
    cons: "⚠️ Cons",
    security: "Security",
    ease: "Ease",
    price: "Price",
    free: "Free",
    free_short: "FREE",
    open_source: "Open Source",
    closed: "Closed",
    visit: "Visit website",
    close: "Close",
    details: "View details",
    cold: "COLD",
    hot: "HOT",
    showing: (n, total) => `Showing ${n} of ${total} wallets`,
    no_results: "No wallets match your filters",
    reset: "Reset filters",
    badges: { defi: "DeFi", mobile: "Mobile", desktop: "Desktop", nfc: "NFC", hw: "Hardware" },
  },
  sk: {
    title: "Porovnávač Peňaženiek",
    subtitle: "35 analyzovaných peňaženiek · Hardvérové + Hot · Nájdi si svoju",
    eyebrow: "TopWallet · Porovnaj",
    filter_category: "Kategória",
    filter_type: "Typ",
    type_all: "Všetky",
    type_cold: "🧊 Cold (Hardvérové)",
    type_hot: "🔥 Hot (Softvérové)",
    sort: "Zoradiť podľa",
    sort_security: "Bezpečnosť",
    sort_ease: "Jednoduchosť",
    sort_price_asc: "Cena ↑",
    sort_price_desc: "Cena ↓",
    chains: "Siete",
    best_for: "Najlepšia pre",
    pros: "✅ Výhody",
    cons: "⚠️ Nevýhody",
    security: "Bezpečnosť",
    ease: "Jednoduchosť",
    price: "Cena",
    free: "Zadarmo",
    free_short: "ZADARMO",
    open_source: "Open Source",
    closed: "Uzavretý",
    visit: "Navštíviť web",
    close: "Zavrieť",
    details: "Detaily",
    cold: "COLD",
    hot: "HOT",
    showing: (n, total) => `Zobrazené ${n} z ${total} peňaženiek`,
    no_results: "Žiadne peňaženky nezodpovedajú filtrom",
    reset: "Resetovať filtre",
    badges: { defi: "DeFi", mobile: "Mobil", desktop: "Desktop", nfc: "NFC", hw: "Hardvér" },
  },
  "zh-CN": {
    title: "钱包对比工具",
    subtitle: "35款钱包分析 · 硬件 + 热钱包 · 找到适合你的",
    eyebrow: "TopWallet · 对比",
    filter_category: "类别",
    filter_type: "类型",
    type_all: "全部",
    type_cold: "🧊 冷钱包（硬件）",
    type_hot: "🔥 热钱包（软件）",
    sort: "排序方式",
    sort_security: "安全性",
    sort_ease: "易用性",
    sort_price_asc: "价格 ↑",
    sort_price_desc: "价格 ↓",
    chains: "网络",
    best_for: "最适合",
    pros: "✅ 优势",
    cons: "⚠️ 劣势",
    security: "安全性",
    ease: "易用性",
    price: "价格",
    free: "免费",
    free_short: "免费",
    open_source: "开源",
    closed: "闭源",
    visit: "访问网站",
    close: "关闭",
    details: "查看详情",
    cold: "冷钱包",
    hot: "热钱包",
    no_results: "没有符合筛选条件的钱包",
    reset: "清除筛选",
    badges: {
      defi: "DeFi",
      mobile: "移动端",
      desktop: "桌面端",
      nfc: "NFC",
      hw: "硬件",
    },
  },
  de: {
    title: "Wallet-Vergleich",
    subtitle: "35 analysierte Wallets · Hardware + Hot · Finde deine",
    eyebrow: "TopWallet · Vergleich",
    filter_category: "Kategorie",
    filter_type: "Typ",
    type_all: "Alle",
    type_cold: "🧊 Cold (Hardware)",
    type_hot: "🔥 Hot (Software)",
    sort: "Sortieren nach",
    sort_security: "Sicherheit",
    sort_ease: "Benutzerfreundlichkeit",
    sort_price_asc: "Preis ↑",
    sort_price_desc: "Preis ↓",
    chains: "Netzwerke",
    best_for: "Am besten für",
    pros: "✅ Vorteile",
    cons: "⚠️ Nachteile",
    security: "Sicherheit",
    ease: "Benutzerfreundlichkeit",
    price: "Preis",
    free: "Kostenlos",
    free_short: "KOSTENLOS",
    open_source: "Open Source",
    closed: "Geschlossen",
    visit: "Website besuchen",
    close: "Schließen",
    details: "Details ansehen",
    cold: "COLD",
    hot: "HOT",
    no_results: "Keine Wallets entsprechen deinen Filtern",
    reset: "Filter zurücksetzen",
    badges: {
      defi: "DeFi",
      mobile: "Mobil",
      desktop: "Desktop",
      nfc: "NFC",
      hw: "Hardware",
    },
  },
};

export const getComparadorUi = (lang) => COMPARADOR_UI[lang] || COMPARADOR_UI.es;
